import CollectionModule from 'client/store/modules/CollectionModule';
import SupportCaseApi from 'client/api/v2/SupportCaseApi';

export class SupportCaseCollection extends CollectionModule {
  constructor() {
    super(SupportCaseApi, 'caseNumber', 'caseNumber');
  }
}

export default new SupportCaseCollection().extractModule();
